export const mailboxMixins = {
  methods: {
    allMailboxes () {
      this.$http.get('/mailboxes')
        .then(response => this.showMailboxes(response))
        .catch((e) => this.error(e))
    },

    showMailboxes (response) {
      this.mailboxes = response.data
    },

    selectMailbox (id) {
      var box = this.mailboxes.find(function (box) {
        return box.id === id
      })
      this.setMailbox(box)
    },

    setMailbox (box) {
      this.mailbox = box
    },

    resetMailbox (id) {
      if (typeof id !== 'undefined') {
        this.$http.get('/mailboxes/' + id)
          .then(response => this.setMailbox(response.data))
          .catch((e) => this.error(e))
      } else {
        this.setBlankMailbox()
      }
    },

    setBlankMailbox () {
      this.mailbox = {
        name: '',
        gmail_address: '',
        team_id: '',
        default_board_id: ''
      }
    },

    error (e) {
      console.log(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mailboxMixins.js